import PulseLoader from "../PulseLoader";
import { useAuthBootstrap } from "./useAuthBootstrap";

export const AuthBootstrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { loading } = useAuthBootstrap();

  if (loading) {
    return (
      <div className="flex flex-col w-full items-center justify-center min-h-[97dvh]">
        <PulseLoader />
      </div>
    );
  }

  return <>{children}</>;
};
